import React, { useState, useEffect, useRef } from 'react';

function StorePage({cards, setCards, username, energy_charge, triggerToast, fetchUserData, setEnergyCharge, clickPower, clickCount, setClickCount, setClickPower, income, setIncome, setEnergy, setMaxEnergy, maxEnergy, onCardsChanged }) {

  const [visibleCards, setVisibleCards] = useState([]);
  const observerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const cardId = entry.target.dataset.id;
          if (entry.isIntersecting) {
            setVisibleCards((prev) => [...new Set([...prev, cardId])]);
          } else {
            setVisibleCards((prev) => prev.filter((id) => id !== cardId));
          }
        });
      },
      { threshold: 0.001, rootMargin: "1000px" } // Расширяем область на 200px
    );

    observerRef.current = observer;

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".card");
    elements.forEach((el) => observerRef.current.observe(el));

    return () => {
      elements.forEach((el) => observerRef.current.unobserve(el));
    };
  }, [cards]);
  const purchaseClickPower = async () => {
    if (clickCount < Math.floor((clickPower ** 1.2 * 300)* 3 )){
      triggerToast("Недостаточно кликов");
    }
    else {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/purchases/click_power`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username }),
      });
      const data = await response.json();
      if (response.ok) {
        setClickPower(Number(data.user.click_power));
        setClickCount(Number(data.user.click_count));
        triggerToast("Вы увеличили силу клика");
      } else {
        triggerToast(data.message || data.error || 'Покупка не выполнена');
      }
    } catch (error) {
      triggerToast('Не удалось связаться с сервером');
    }
  }
  };
  const purchaseAutoClicks = async () => {
    if (clickCount < Math.floor(income ** 1.05 * 100)){
      triggerToast("Недостаточно кликов");
    }
    else {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/purchases/auto_clicks`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username }),
      });
      const data = await response.json();
      if (response.ok) {
        setIncome(Number(data.user.income_per_hourr));
        setClickCount(Number(data.user.click_count));
        triggerToast("Вы увеличили доход");
      } else {
        triggerToast(data.message || data.error || 'Покупка не выполнена');
      }
    } catch (error) {
      triggerToast('Не удалось связаться с сервером');
    }
  }
  };

  const refreshEnergy = async () => {
    if (clickCount < 50000){
      triggerToast("Недостаточно кликов");
    }
    else {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/purchases/refresh_energy`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username }),
      });
      const data = await response.json();
      
      if (response.ok) {
        setEnergy(Number(data.user.energy));
        setClickCount(Number(data.user.click_count));
        setEnergyCharge(Number(data.user.energy_charges));
        triggerToast("Вы перезарядились");
      } else {
        triggerToast(data.message || data.error || 'Энергия не восстановлена');
      }
    } catch (error) {
      triggerToast('Не удалось связаться с сервером');
    }
  }
  };
  

  const increaseMaxEnergy = async () => {
    if (clickCount < 250 + Math.floor(maxEnergy / 100) * 15000){
      triggerToast("Недостаточно кликов");
    }
    else {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/purchases/increase_max_energy`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username }),
      });
      const data = await response.json();
      if (response.ok) {
        setMaxEnergy(Number(data.user.max_energy));
        setClickCount(Number(data.user.click_count));
        triggerToast("Вы увеличили максимальную энергию");
      } else {
        triggerToast(data.message || data.error || 'Покупка не выполнена');
      }
    } catch (error) {
      triggerToast('Не удалось связаться с сервером');
    }
  }
  };
  const [isUpgradeInProgress, setIsUpgradeInProgress] = useState(false);

  const upgradeCard = async (cardId, currentLevel) => {
    if (isUpgradeInProgress) {
      triggerToast("Прокачка уже в процессе, подождите...");
      return;
    }

    const upgradeCost = 200 * (currentLevel + 1);
    if (clickCount < upgradeCost) {
      triggerToast("Недостаточно кликов для прокачки ");
      return;
    }

    try {
      setIsUpgradeInProgress(true); // Устанавливаем флаг блокировки

      const response = await fetch(`${process.env.REACT_APP_API_URL}/cards/upgrade`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, cardId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to upgrade card");
      }

      const data = await response.json();
      updateCardLevelLocally(cardId, data.newLevel);
      setClickCount((previous) => Number.isFinite(Number(data.clickCount))
        ? Number(data.clickCount)
        : previous - Number(data.upgradeCost || upgradeCost));
      await onCardsChanged?.();

      triggerToast("Карта успешно прокачана!");
    } catch (err) {
      triggerToast(err.message || "Ошибка при прокачке карты.");
    } finally {
      setIsUpgradeInProgress(false); // Снимаем флаг блокировки
    }
  };

  const updateCardLevelLocally = (cardId, newLevel) => {
    setCards((prevCards) =>
      prevCards.map((card) =>
        card.id === cardId ? { ...card, level: newLevel } : card
      )
    );
  };

  


  return (
    <div className='container_'>

      <h1>Магазин</h1>

      <div className='element' style={{animation: 'slideInLeft 0.3s ease-out forwards'}}>
        <img src='/assets/imgur/bqfSBQi.png' alt='' />
        <div className='group'>
          <div className='info_row'>Сила клика</div>
          <div className='info_row_sub_cnt'>
          <span>Ур.{clickPower}</span>
          <span>{clickPower}→{clickPower+1}</span>
          </div>
        </div>
        <button className='btnbuy' onClick={purchaseClickPower}><img src='/assets/currency-coin-v2.png' alt='' /> {Math.floor((clickPower ** 1.2 * 300)* 3 )} </button>
      </div>

      <div className='element'  style={{animation: 'slideInRight 0.3s ease-out forwards'}}>
        <img src='/assets/imgur/dr13M3o.png' alt='' />
        <div className='group'>
          <div className='info_row'>Доход</div>
          <div className='info_row_sub_cnt'>
          <span>Ур.{income/100}</span>
          <span>{income}→{income+100}</span>
          </div>
        </div>
        <button className='btnbuy' onClick={purchaseAutoClicks}><img src='/assets/currency-coin-v2.png' alt='' /> {Math.floor(income ** 1.05 * 100)}</button>
      </div>

      <div className='element'  style={{animation: 'slideInLeft 0.3s ease-out forwards'}}>
        <img src='/assets/imgur/y9DZRmJ.png' alt='' />
        <div className='group'>
          <div className='info_row'>Подзарядка</div>
          <div className='info_row_sub_cnt'>
          <span>Осталось {energy_charge}/3</span>
          </div>
        </div>
        <button className='btnbuy' disabled={energy_charge <= 0} onClick={refreshEnergy}><img src='/assets/currency-coin-v2.png' alt='' /> 50000</button>
      </div>

      <div className='element'  style={{animation: 'slideInRight 0.3s ease-out forwards'}}>
        <img src='/assets/imgur/l390H4Y.png' alt='' />
        <div className='group'>
          <div className='info_row'>Энергия</div>
          <div className='info_row_sub_cnt'>
          <span>Ур.{(maxEnergy-1000)/100}</span>
          <span>{maxEnergy}→{maxEnergy+100}</span>
          </div>
        </div>
        <button className='btnbuy' onClick={increaseMaxEnergy}><img src='/assets/currency-coin-v2.png' alt='' /> {250 + Math.floor(maxEnergy / 100) * 15000} </button>
      </div>

      <h1>Пассивный доход</h1>
      <div className="cards">
      {cards.map((card) => (
        <div
  key={card.id}
  data-id={card.id}
  className={`card ${card.unlocked ? 'card-unlocked' : 'card-locked'} ${visibleCards.includes(card.id.toString()) ? "visible" : "hidden"}`}
>
  <div className="card-image">
    <img src={card.img?.startsWith('/') ? card.img : `/cards/${card.img}.png`} alt={card.name} />
  </div>
  <div className="card-content">
    <span className={`card-rarity card-rarity-${String(card.rarity || 'common').toLowerCase()}`}>
      {card.rarity || 'common'}
    </span>
    <h3 className="card-title">{card.name}</h3>
    <p className="card-subtitle">{card.unlocked ? (card.description || "Описание") : (card.condition || 'Выполните условие, чтобы открыть карточку')}</p>
    <div className="card-stats">
    <p className="stats-label">Прибыль в 24 часа:</p>
      <p className="stats-value">{card.unlocked ? card.base_clicks_per_hour * (card.level || 0) : "???"}</p>
    </div>
    <div className="card-level">
    <p className="card-level-text">{card.unlocked ? `Ур. ${card.level || 0}` : 'Не открыта'}</p>
    <button 
      className="card-upgrade-button"
      disabled={!card.unlocked || isUpgradeInProgress}
      onClick={() => upgradeCard(card.id, card.level || 0)}
    >
      {card.unlocked ? `- ${200 * ((Number(card.level) || 0) + 1)}` : 'Закрыто'}
    </button>
    </div>
  </div>
</div>
      ))}
    </div>
      <div style={{ height: '40px' }}></div> 
    </div>
  );
}

export default StorePage;
